import { Http } from '@/lib/http';
import { URL_PATHS } from './constants';

export default class AccountManagementService extends Http {
  constructor() {
    super();
  }

  search(
    params = {
      trn: '',
      firstName: '',
      lastName: '',
      dateOfBirth: '',
      mainAccountNumber: ''
    },
    offset = 0,
    limit = 25
  ) {
    return this.httpClient().post(`${URL_PATHS.LOANPRO_APP}/accounts/search`, {
      ...params,
      offset,
      limit
    });
  }

  getAccountById(id) {
    return this.httpClient().get(`${URL_PATHS.LOANPRO_APP}/accounts/${id}`);
  }

  updateAccount(mainAccountNumber, data) {
    return this.httpClient().patch(
      `${URL_PATHS.LOANPRO_APP}/accounts/${mainAccountNumber}`,
      data
    );
  }

  createAccount(data) {
    return this.httpClient().post(`${URL_PATHS.LOANPRO_APP}/accounts`, data);
  }

  async doesAccountNumberExist(accountId, accountNumber) {
    try {
      await this.httpClient().head(
        `${URL_PATHS.LOANPRO_APP}/accounts/${accountId}/${accountNumber}`,
      );
      return true;
    } catch (e) {
      const { response } = e;
      if (response) {
        if (response?.status == 404) {
          return false;
        }
      }
      throw e;
    }
  }

  async doesTRNExist(personId, trn) {
    const { data } = await this.httpClient().get(`${URL_PATHS.LOANPRO_APP}/accounts/persons/${personId}/trn/${trn}`);
    return data;
  }

}
